// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const ariados: PokeData = {
  "id": 168,
  "name": "ariados",
  "height": 11,
  "weight": 335,
  "base_experience": 140,
  "types": [
    PokeType.BUG,
    PokeType.POISON
  ],
  "api_moves": [
    "swords-dance",
    "poison-sting",
    "pin-missile",
    "absorb",
    "string-shot",
    "psychic",
    "agility",
    "night-shade",
    "screech",
    "focus-energy",
    "constrict",
    "leech-life",
    "fury-swipes",
    "spider-web",
    "scary-face",
    "sucker-punch",
    "poison-jab",
    "shadow-sneak",
    "cross-poison",
    "bug-bite",
    "sticky-web",
    "fell-stinger",
    "venom-drench",
    "infestation",
    "toxic-thread"
  ],
  "moves": [
    "pin-missile",
    "string-shot",
    "psychic",
    "night-shade",
    "scary-face",
    "poison-jab",
    "shadow-sneak",
    "bug-bite",
    "sticky-web",
    "venom-drench",
    "sludge-bomb",
    "lunge",
    "poison-gas"
  ],
  "evolution_chain": {
    "id": 85,
    "item": null,
    "species": [
      {
        "name": "spinarak",
        "order": 199,
        "types": [
          PokeType.BUG,
          PokeType.POISON
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "ariados",
        "order": 200,
        "types": [
          PokeType.BUG,
          PokeType.POISON
        ],
        "evolves_from_species_id": 167,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 22,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 140,
    "speed": 80,
    "ability_power": 180
  },
  "stat_changes": [],
  "catch_rate": 90,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
